module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Bold.b6db10f5.ttf";